import React,{useState,useEffect} from 'react'
import { MwInputText } from '../../../components/ui'
import MwSelectorWarehouses from '../../../components/ui/MwSelectorWarehouses'
import { useTranslation } from 'react-i18next'
 
const StockTakingForm = ({stocktakingForm,setStocktakingForm,code}) => {

    const [t,i18n ] = useTranslation('global')

    const [selectedItem,setSelectedItem] = useState();

    useEffect(() => {
        if(selectedItem){
            setStocktakingForm({...stocktakingForm,warehouse:selectedItem,code:code})
            console.log(stocktakingForm);
        }
    },[selectedItem]);

  

    return (
        <div className='flex gap-7 rounded-xl bg-slate-100 p-4 my-4'>
            <div className='flex-1'>
                <MwSelectorWarehouses
                    withLabel = {true}
                    initalValue = {t('stocktaking.select_warehouse')}
                    selectedItem = {selectedItem}
                    setSelectedItem={setSelectedItem}
                    />
            </div>
            <div className='flex-1'>
                <MwInputText
                    label={t('stocktaking.inventory_code')}
                    placeholder={t('stocktaking.inventory_code_placeholder')}
                    value ={stocktakingForm?.code}
                    onChange = {(e) =>setStocktakingForm({...stocktakingForm,code:e.target.value})}
                    />
            </div>
            <div className='flex-1'>
                <MwInputText
                    // inputType='date'
                    initalValue = {stocktakingForm.stocktaking_at}
                    label={t('stocktaking.inventory_date')}
                    placeholder={t('stocktaking.inventory_date_placeholder')}
                    value = {stocktakingForm?.stocktaking_at}
                    onChange = {(e) =>setStocktakingForm({...stocktakingForm,stocktaking_at:e.target.value})}
                    />
            </div>
        </div>
    )
}

export default StockTakingForm